module.exports = __webpack_public_path__ + "static/img/kaoshi.1e48c06.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productlist/kaoshi.jpg
// module id = YlOT
// module chunks = 1